import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './Components/Login';
import SignUp from './Components/Signup';
import Header from './Components/NavBar';
import Profile from './Components/Profile';
import DankMemes from './Components/DankMemes';
import MemeCreator from './Components/MemeCreator';
import ParticleComponent from "./Components/ParticleComponent";

class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isAuthenticated: false,
      accountCreated: false,
      token: {},
      myMemes: [],
      userId: '',
      username: '',
    }
  }

  componentDidMount = () => {
    try{
      const loggedInUser = localStorage.getItem('user');
      if (loggedInUser) {
        const foundUser = JSON.parse(loggedInUser);
        this.setState({isAuthenticated: foundUser.isAuthenticated, token: foundUser.token, myMemes: foundUser.myMemes, userId: foundUser.userId, username: foundUser.username});
      }
    } catch (err) {
      console.error(err.message);
    }
  }

	handleSignup = async (e, username, email, password) => {
		e.preventDefault();
		try {
			const server = process.env.REACT_APP_SERVER;
			const results = await axios.post(`${server}/signup`, { username, email, password });
      this.setState({accountCreated: true})
		} catch (err) {
			console.error(err.message);
		}
	};

  handleLogin = async(e, username, password) => {
    e.preventDefault();
    try {
      const server = process.env.REACT_APP_SERVER;
      const results = await axios.post(`${server}/signin`, {}, {auth:{username: username, password: password}});
      this.setState({isAuthenticated: true, token: results.data.token, myMemes: results.data.user.memes, userId: results.data.user.id, username: username});
      localStorage.setItem('user', JSON.stringify(this.state));
    } catch (err) {
      console.error(err.message);
    }
  }

  signOut = (event) => {
    this.setState({isAuthenticated: false, token: {}, myMemes: [], userId: '', username: ''});
    localStorage.clear();
  }

  render(){
    
    return (
      <Router>
        <div className="App">
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%"
            }}
          >
            <ParticleComponent />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
            >
              <Header isAuthenticated={this.state.isAuthenticated} signOut={this.signOut}/>
              {
                <Routes>
                  <Route exact path='/'
                    element = {this.state.isAuthenticated ? <Navigate to="/community" /> : <React.Fragment><Login handleLogin = {this.handleLogin}/></React.Fragment>}
                  />
                  <Route path="/sign-in"
                    element = {this.state.isAuthenticated ? <Navigate to="/community" /> : <Login handleLogin = {this.handleLogin}/>}
                  />
                  <Route path="/sign-up"
                    element = {this.state.accountCreated ? <Navigate to="/sign-in" /> : <React.Fragment><SignUp handleSignup = {this.handleSignup}/></React.Fragment>}      
                  />
                  <Route path="/creativity"
                    element = 
                    {
                    !this.state.isAuthenticated ?
                    <>
                    <Navigate to="/sign-in" /></> 
                    :
                    <>
                      <Profile
                        userId = {this.state.userId}
                        username = {this.state.username}
                        token = {this.state.token}
                      />
                    </>
                    }
                  />
                  <Route path="/community"
                   element = 
                    {
                    !this.state.isAuthenticated ? 
                    <>
                      <Navigate to="/sign-in" /> 
                    </>
                    :
                    <>
                      <DankMemes
                        userId = {this.state.userId}
                        username = {this.state.username}
                        token = {this.state.token}
                      />
                    </>
                    }
                  />
                  <Route path="/collaboration"
                    element = {
                    !this.state.isAuthenticated ? 
                    <Navigate to="/sign-in" /> 
                    :
                    <>
                      <MemeCreator
                        userId = {this.state.userId}
                        username = {this.state.username}
                        token = {this.state.token}
                      />
                    </>
                    }
                  />
                </Routes>
              }
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
